import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import Collapse, { Panel } from 'rc-collapse';

import 'rc-collapse/assets/index.css';
import './BasketUpsellAccordion.scss';

import { UpsellTypes, UpsellModel, AddUpsellOptionModel, BasketItemModel } from 'models/Basket';
import { AppState } from 'store';
import { generateDispatchToPropsMap } from 'helpers';
import { addUpsell, AddUpsellFunc } from 'store/basket/actions';
import { BasketUpsellItemHeader } from './BasketUpsellItemHeader/BasketUpsellItemHeader';
import { BasketUpsellItemContent } from './BasketUpsellItemContent/BasketUpsellItemContent';

interface OwnProps {
}

interface StateProps {
    availableUpsells: UpsellModel[];
    basketItems: BasketItemModel[];
    basketLoadingUpsells: UpsellTypes[];
}

interface DispatchProps {
    addUpsell: AddUpsellFunc;
}

interface OwnState {
    activeKeys: string[];
}

class BasketUpsellAccordion extends Component<OwnProps & StateProps & DispatchProps, OwnState> {
    constructor(props: OwnProps & StateProps & DispatchProps) {
        super(props);
        this.state = { activeKeys: [] };
    }

    handleCollapseChange = (activeKeys: string[]) => {
        this.setState({ activeKeys });
    };

    handleAddToOrder = (upsellItem: UpsellModel, selectedOption: AddUpsellOptionModel) => {
        this.props.addUpsell(upsellItem, selectedOption);
    };

    render(): JSX.Element | null {
        if (this.props.availableUpsells.length) {
            return (
                <div className='upsell-accordion__wrapper'>
                    <div className='upsell-header'>Extras you may need</div>
                    <Collapse
                        accordion={false}
                        onChange={this.handleCollapseChange}
                        activeKey={this.state.activeKeys}
                    >
                        {this.renderUpsellItems()}
                    </Collapse>
                </div>
            );
        }

        return null;
    }

    renderUpsellItems(): JSX.Element[] {
        return this.props.availableUpsells.map((upsellItem: UpsellModel) => (
            <Panel
                disabled={upsellItem.isDisabled}
                key={UpsellTypes[upsellItem.type]}
                header={<BasketUpsellItemHeader
                    upsellItem={upsellItem}
                    isUpsellAdding={this.props.basketLoadingUpsells.some(basketLoadingUpsell => basketLoadingUpsell === upsellItem.type)}
                    onAddToOrder={this.handleAddToOrder}
                    isDisabled={upsellItem.isDisabled}
                />}
            >
                {!upsellItem.isDisabled && <BasketUpsellItemContent upsellItem={upsellItem} />}
            </Panel>
        ));
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        availableUpsells: state.basketState.availableUpsells,
        basketItems: state.basketState.basket!.entries,
        basketLoadingUpsells: state.basketState.basketLoadingUpsells
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [addUpsell]);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketUpsellAccordion);